import { useState } from 'react';

import { communicationPreferences } from '../../services/communicationPreferences/communicationPreferences';
import type { Environment } from '../../types/environment';
import * as tracking from './tracking';

export const redirectUrl = '/emails/thanks-for-signing-up';

export const useCommunicationPreferences = (env: Environment) => {
  const [hasSignUpError, setHasSignUpError] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSignUp = async (email: string) => {
    setLoading(true);
    const result = await communicationPreferences(env, email);
    if (result) {
      setLoading(false);
      if (result instanceof Error) {
        tracking.sendNewsletterSubmissionErrorEvent(result.message);
        setHasSignUpError(true);
      } else {
        await tracking.sendNewsletterSubmissionSuccessEvent(email);
        window.location.assign(redirectUrl);
      }
    }
  };

  return { hasSignUpError, loading, onSignUp };
};
